<script>
import StoryGroup from '@rei/story-group';
import LandingImageComponent from '@rei/landing-image-component';
import { LandingContentBlock } from '@rei/landing-content-block';
import CouponCategories from '../../../pages/coupon/components/coupon-categories/CouponCategories.vue';
import {
  formatCategories,
  formatHeading,
} from '../../../utils/formatCmsData';
import formatCouponConfig from '../../../utils/formatCoupon';
import { getCouponMustache } from '../../../utils/formatText';
import palettes from '../../mixins/palettes';

export default {
  name: 'CouponPlacement',
  components: {
    LandingImageComponent,
    StoryGroup,
    LandingContentBlock,
    CouponCategories,
  },
  mixins: [palettes],
  props: {
    coupon: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  computed: {
    content() {
      const { content } = this.coupon;
      return content && {
        ...content,
        heading: {
          ...content.heading,
          text: this.couponMustache(content.heading.text),
        },
        body: this.couponMustache(content.body),
      };
    },
    media() {
      return this.coupon?.media;
    },
    couponConfig() {
      const { children } = this.coupon || {};
      const options = {
        excludeEndYear: true,
      };
      return formatCouponConfig(children?.['resource-1']?.config, options);
    },
    couponCategories() {
      const { mergedMediaAndActions } = this.coupon || {};
      const heading = formatHeading(mergedMediaAndActions);
      const categories = formatCategories(mergedMediaAndActions?.mediaAndActions?.categories);
      return categories.length ? { heading, categories } : null;
    },
    renderContent() {
      return !!this.couponConfig.code && !!this.couponConfig.end;
    },
    couponMustache() {
      return getCouponMustache(this.couponConfig);
    },
  },
};
</script>

<template>
  <div
    :style="cssSurfacePaletteVars"
    class="coupon-placement"
    data-ui="coupon-placement"
  >
    <div class="coupon-wrapper">
      <div class="coupon-wrapper__content">
        <story-group padding-classes="">
          <template
            v-if="media"
            #column-1
          >
            <landing-image-component
              v-bind="media"
              data-ui="coupon-image"
              custom-classes="coupon-image"
            />
          </template>
          <template
            v-if="renderContent"
            #column-2
          >
            <landing-content-block v-bind="content" />
          </template>
        </story-group>
      </div>
    </div>
    <div
      v-if="couponCategories"
      class="mountain-icon"
    />
    <coupon-categories
      v-if="couponCategories"
      v-bind="couponCategories"
      class="coupon-categories"
    />
  </div>
</template>
<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';
@import '@rei/cdr-component-variables/dist/scss/index.scss';

.coupon-wrapper {
  background-color: var(--palette-background-color);
  padding: $cdr-space-two-x 0;

  @include cdr-sm-mq-up {
    padding: $cdr-space-three-x 0;
  }

  &__content {
    @include cdr-container;

    .story-group__column:first-child {
      @include cdr-sm-mq-up {
        display: flex;
        justify-content: center;
      }
    }
  }
}

.coupon-categories {
  @include cdr-container;
  padding-top: $cdr-space-three-x;
}

.coupon-image {
  width: 100%;
  @include cdr-sm-mq-up {
    width: auto;
  }
}

.mountain-icon {
  position: absolute;
  z-index: 1;
  left: 50%;
  display: flex;
  transform: translate(-50%,0);
  align-items: flex-start;

  &:before {
    width: 0;
    height: 0;
    border-style: solid;
    content: '';
    border-width: 30px 25px 0 25px;
    border-color: var(--palette-background-color) transparent transparent transparent;
  }

  &:after {
    margin-left: -12px;
    width: 0;
    height: 0;
    border-style: solid;
    content: '';
    border-width: 17px 15px 0 15px;
    border-color: var(--palette-background-color) transparent transparent transparent;
  }
}
</style>
